<script>
import axios from "axios";

export default {

    data() {
        return {
            showRemoveModal: false
        }
    },

    methods: {
        async removeUser() {
            try {

                await axios.delete('/api/team/' + this.record.id);
                window.notify.message('Successfully removed user', 'success');
                this.$emit('refreshRecords');
                this.showDeleteModel = false;
            }catch(err) {
                window.notify.message(err.toString(), 'error');
            }
        }
    },

    props: {
        record: {
            required: true,
            type: Object
        }
    }

}
</script>
<template>
    <tr>
        <td>{{ record.first_name }}</td>
        <td>{{ record.last_name }}</td>
        <td>{{ record.email }}</td>
        <td>
            <i class="fa fa-times cursor-pointer" @click="showRemoveModal = true"></i>
            <modal
                v-if="showRemoveModal"
                modalWidth="600px"
                @close="showRemoveModal = false">

                <span slot="header">Delete Account Invitation?</span>

                <slot slot="body">
                    <p>Are you sure you want to remove this user?</p>
                    <button class="inputbutton1 rounded" @click="removeUser">
                        Remove
                    </button>
                    <button class="inputbutton1 rounded" @click="showRemoveModal = false">
                        Cancel
                    </button>
                </slot>
            </modal>
        </td>
    </tr>
</template>
